import axios from 'axios'
import { errorHandler } from '@/shared/errorHandler'

export default {
    login(usuario) {
        let promisse = axios.post(
            `${process.env.VUE_APP_API_ADMINISTRACAO_URL}${process.env.VUE_APP_API_PATH}/administracao/autenticacao/login`,
            usuario
        )
        return promisse
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

    // config () {
    //   let promisse = axios.get(`${process.env.ROOT_URL}${process.env.ROOT_API}/autenticacao/config`)
    //   return promisse.then((response) => {
    //     return response.data
    //   }).catch((error) => {
    //     return errorHandler(error)
    //   })
    // }
}
